import { setGlobalContext, GlobalContext } from '@webtv/error-reporting-v2';
import { CPUCapability, DEFAULT_DEVICE } from './models';
var cachedLgDevice;

var isWebOs = function isWebOs(userAgent) {
  return !!userAgent.match(/^(?=.*Web0S).*$/im);
};

export var toLgDevice = function toLgDevice(webOsDevice) {
  return {
    friendlyName: webOsDevice.modelName,
    capabilities: {
      cpu: CPUCapability.High,
      cssVariables: false
    },
    platform: 'lg',
    osVersion: webOsDevice.sdkVersion
  };
};
export var GENERIC_LG = {
  friendlyName: 'webOS Generic Device',
  capabilities: {
    cpu: CPUCapability.High,
    cssVariables: false
  },
  platform: 'lg'
};
export var getLgDevice = function getLgDevice() {
  var _cachedLgDevice;

  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  if (!isWebOs(userAgent)) {
    return DEFAULT_DEVICE;
  }

  window.webOS.deviceInfo(function (deviceInfo) {
    var currentDevice = toLgDevice(deviceInfo);

    if (currentDevice !== cachedLgDevice) {
      setGlobalContext(GlobalContext.DeviceName, currentDevice.friendlyName);
      cachedLgDevice = currentDevice;
    }
  });
  return (_cachedLgDevice = cachedLgDevice) !== null && _cachedLgDevice !== void 0 ? _cachedLgDevice : GENERIC_LG;
};